/*!
  Atom, by Koding Themes
  subscriptions.js
  https://kodingthemes.com
*/

if(window.theme.pageType === 'product'){
	const radioInp = document.querySelector(".spg-radio-input");
	const oneTime = document.querySelector("#loop-one-time-purchase");
	const subSelect = document.querySelector("select[id^=spg-select]");
	const subBtn = document.querySelector("button[type='submit'][name='add']");
	//functions/logic
	function updateWidgetCurrentVariant(id) {
		var _widget = document.getElementById("loop-widget-fieldset");
		if(_widget) {
			_widget.dataset.currentVariantId = id;
		}
	}
	function updateWidgetCurrentSellingPlan(id, name) {
		var _widget = document.getElementById("loop-widget-fieldset");
		if (!_widget) return;
		_widget.dataset.currentSellingPlanId = id;
		_widget.dataset.currentSellingPlanName = name;
	}
	function addSubscriptionToCartFunctionality(type, el) {
		var add_to_cart_btn = document.querySelector("button[type='submit'][name='add']");
		if (!add_to_cart_btn) return;
		if(type === "S") {
			var cartLabel = add_to_cart_btn.querySelector("[data-adding-cart]");
			if (cartLabel) cartLabel.textContent = window.theme.addSubscription;
			add_to_cart_btn.disabled = false;

			let sp_id = el.target.id.split("-")[3];
			let sp_name = el.target.id.substring(el.target.id.indexOf(sp_id)+sp_id.length+1);
			var _widget = document.getElementById("loop-widget-fieldset");
			if (_widget) {
				_widget.dataset.currentSellingPlanId = sp_id;
				_widget.dataset.currentSellingPlanName = sp_name;
			}
			var _url = new URL(window.location);
			_url.searchParams.set('selling_plan', sp_id);
			history.pushState(null, null, _url);
		}
		else {
			var cartLabel = add_to_cart_btn.querySelector("[data-adding-cart]");
			if (cartLabel) cartLabel.textContent = window.theme.addToCart;
		}
	}
	var firstTimeUrl = document.URL;
	document.addEventListener('change', function() {
		var currentPageUrl = document.URL;
		var url = new URL(currentPageUrl);
		var isVariantUrl = url.searchParams.get("variant");
		if(isVariantUrl && firstTimeUrl !== currentPageUrl) {
			firstTimeUrl = currentPageUrl;
			updateWidgetCurrentVariant(isVariantUrl);
		}
	});
	var spg = Array.from(document.querySelectorAll("input[name=loop_purchase_option]"));
		spg.forEach(el => el.addEventListener('change', (el) => {
		if(el.target.id!="loop-one-time-purchase"){
			addSubscriptionToCartFunctionality("S", el); //S for subscription
		}
		else {
			addSubscriptionToCartFunctionality("N", el); //N for normal
		}
	}));
	//handle <select> change in selling plan
	var sp_selects = Array.from(document.querySelectorAll("[id*=spg-select]"));
	sp_selects.forEach(function(selectEl) {
		selectEl.addEventListener('change', function(e) {
			var sp_id = e.target.value;
			var _url = new URL(window.location);
			_url.searchParams.set('selling_plan', sp_id);
			var stickyPlan = document.querySelector(".js-sticky-product-selling-plan");
			if (stickyPlan) stickyPlan.value = sp_id;
			window.history.pushState({}, '', _url);
			var sp_name = e.target.options[e.target.selectedIndex].dataset.sellingPlanName;
			updateWidgetCurrentSellingPlan(sp_id, sp_name);
		});
	});
	if(oneTime){
		oneTime.addEventListener("click", function() {
			var params = new URLSearchParams(window.location.search);
			params.delete("selling_plan");
			var spgSelect = document.querySelector("select[id^=spg-select]");
			if (spgSelect) spgSelect.selectedIndex = -1;
			var stickyPlan = document.querySelector(".js-sticky-product-selling-plan");
			if (stickyPlan) stickyPlan.value = '';
			var _widget = document.getElementById("loop-widget-fieldset");
			if (_widget) {
				_widget.dataset.currentSellingPlanId = "";
				_widget.dataset.currentSellingPlanName = "";
			}
			var paramStr = params.toString();
			var newUrl = paramStr ? window.location.pathname + '?' + paramStr : window.location.pathname;
			window.history.replaceState({}, '', newUrl);
		});
	}
	// if one time purchase doesn't exist, default to subscription
	document.addEventListener("DOMContentLoaded", function() {
		if(oneTime == null && radioInp && subSelect){
			radioInp.checked = true;
			subSelect.setAttribute("name", "selling_plan");
		}
	});
	function updateSubName() {
		if(radioInp.checked && subSelect){
			subSelect.setAttribute("name", "selling_plan");
		}
	}
	// invoke the function
	if(radioInp){
		radioInp.addEventListener("click", updateSubName);
		//set button text if subscription radio is checked
		if(radioInp.checked && subBtn){
			var cartLabel = subBtn.querySelector("[data-adding-cart]");
			if (cartLabel) cartLabel.innerText = window.theme.addToCart;
		}
	}
}
